import { AppConsts } from './../../consts/app-consts';
import { AdminProduct } from './../../../list-purchase/share/interface/base';
import { MasterItem } from './../../interfaces/master-model';
import { OcrResponse, InvoiceUpdateResponse, SkuModel, CheckSkuRequest, CampaignSkuResponse, TopUIConfig } from './../../interfaces/mechanic/ocr-model';
import { environment } from 'environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from 'app/shared/services/api.service';
import { Injectable } from '@angular/core';
import { Config } from 'app/config/config';

@Injectable({
  providedIn: 'root'
})
export class MechanicService {
  // Public properties
  //public _ocrResponse: OcrResponse;
  //public _invoiceUpdateRes: InvoiceUpdateResponse;
  public _ocrResponse: BehaviorSubject<OcrResponse>;
  public _invoiceUpdateRes: BehaviorSubject<InvoiceUpdateResponse>;
  public _bankerGift: BehaviorSubject<string>;
  public _topUIConfig : BehaviorSubject<TopUIConfig>;
  constructor(private apiService: ApiService) {
    this._ocrResponse = new BehaviorSubject<OcrResponse>(JSON.parse(localStorage.getItem(AppConsts.ocrResponseKey)));
    this._invoiceUpdateRes = new BehaviorSubject<InvoiceUpdateResponse>(JSON.parse(localStorage.getItem(AppConsts.invoiceUpdateResponseKey)));
    this._bankerGift = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('BankerGift')));
    this._topUIConfig = new BehaviorSubject<TopUIConfig>(JSON.parse(localStorage.getItem(AppConsts.topUIConfig)));
  }

  public get currentBankerGift(): string
  {
    return this._bankerGift.value;
  }

  public get currentOcrResponse(): OcrResponse
  {
    return this._ocrResponse.value;
  }

  public get currentInvoiceResponse(): InvoiceUpdateResponse
  {
    return this._invoiceUpdateRes.value;
  }
  
  public get topUIConfig(): TopUIConfig {
    return this._topUIConfig.value;
  }
  

  updateOcrReponse(_ocrResponse: OcrResponse) {
    if(!_ocrResponse)
    {
      localStorage.removeItem(AppConsts.ocrResponseKey);
    }
    localStorage.setItem(AppConsts.ocrResponseKey, JSON.stringify(_ocrResponse));
    this._ocrResponse.next(_ocrResponse);
  }

  updateBankerGift(gift: string) {
    if(!gift)
    {
      localStorage.removeItem("BankerGift");
    }
    localStorage.setItem("BankerGift", JSON.stringify(gift));
    this._bankerGift.next(gift);
  }

  updateInvoiceResponse(_invoiceUpdateRes: InvoiceUpdateResponse) {
    if(!_invoiceUpdateRes)
    {
      localStorage.removeItem(AppConsts.invoiceUpdateResponseKey);
    }
    localStorage.setItem(AppConsts.invoiceUpdateResponseKey, JSON.stringify(_invoiceUpdateRes));
    this._invoiceUpdateRes.next(_invoiceUpdateRes);
  }

  updateTopUIConfig(_topUIConfig : TopUIConfig){
    if(!_topUIConfig)
    {
      localStorage.removeItem(AppConsts.topUIConfig);
    }
    localStorage.setItem(AppConsts.topUIConfig, JSON.stringify(_topUIConfig));
    this._topUIConfig.next(_topUIConfig);
  }

  public executeOcrInvoice(postData: any, callBack: any):void
  {
    this.apiService.post<OcrResponse>(Config.unileverApiPath.invoiceOcr, postData, environment.unileverApiHost).subscribe(res => {
      this.updateOcrReponse(res);
      callBack();
    });
  }

  public resetSessionData(): void
  {
    localStorage.removeItem('SignalRCurrentSession');
    localStorage.removeItem('INVOICE_RESPONSE_KEY');
    localStorage.removeItem('BankerGift');
    localStorage.removeItem('OCR_RESPONSE_KEY');
    localStorage.removeItem(AppConsts.topUIConfig);
  }

  public getMall()
  {
    return this.apiService.get<MasterItem[]>(Config.unileverApiPath.getMallByCampaign, environment.unileverApiHost);
  }

  public getStoreByMall(mallName: string)
  {
    return this.apiService.get<MasterItem[]>(`${Config.unileverApiPath.getStoreBycampaign}?mallName=${mallName}`, environment.unileverApiHost);
  }

  public getMallByCampaign()
  {
    return this.apiService.get<MasterItem[]>(Config.unileverApiPath.getMallByCampaign, environment.unileverApiHost);
  }

  public getStoreByMallCampaign(mallName: string)
  {
    return this.apiService.get<MasterItem[]>(`${Config.unileverApiPath.getStoreBycampaign}?mallName=${mallName}`, environment.unileverApiHost);
  }

  public updateInvoice(postData: any): Observable<InvoiceUpdateResponse>
  {
    return this.apiService.post<InvoiceUpdateResponse>(Config.unileverApiPath.updateInvoice, postData, environment.unileverApiHost);
  }

  public getProductAdminByMechanic(mechanic: string): Observable<AdminProduct[]>
  {
    return this.apiService.get<AdminProduct[]>(`${Config.unileverApiPath.adminProductByMechanic}?mechanic=${mechanic}`,environment.unileverApiHost);
  }

  public getCampaignSku(mechanic: string, invoiceId: string)
  {
    return this.apiService.get<CampaignSkuResponse>(`${Config.unileverApiPath.getCampaignSku}?mechanicType=${mechanic}&invoiceId=${invoiceId}`,environment.unileverApiHost);
  }
  public checkSku(skus: SkuModel[], invoiceId: string, turn: number)
  {
    var request = new CheckSkuRequest();
    request.invoiceHeaderId = invoiceId;
    request.skus = skus;
    request.maxTurn = turn;
    return this.apiService.post<boolean>(`${Config.unileverApiPath.checkSku}`, request,environment.unileverApiHost);
  }

  public getTopUIConfig(): Observable<TopUIConfig> {
    return this.apiService.get<TopUIConfig>(Config.unileverApiPath.getTopUIConfig, environment.unileverApiHost)
  }
}
